function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { version as KJ_UPLOADER_VERSION } from '../../../../package.json';
import FilePresenter from './FilePresenter';

var EventPresenter = /*#__PURE__*/function () {
  function EventPresenter() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, EventPresenter);

    this.update(data);
  }

  _createClass(EventPresenter, [{
    key: "update",
    value: function update(_ref) {
      var _ref$filePresenters = _ref.filePresenters,
          newFilePresenters = _ref$filePresenters === void 0 ? [] : _ref$filePresenters,
          _ref$errors = _ref.errors,
          newErrors = _ref$errors === void 0 ? [] : _ref$errors;
      this.filePresenters = [].concat(_toConsumableArray(this.filePresenters || []), _toConsumableArray(newFilePresenters));
      this.errors = [].concat(_toConsumableArray(this.errors || []), _toConsumableArray(newErrors), _toConsumableArray(FilePresenter.errorsFrom(this.filePresenters)));
      return this;
    } // The EventPresenter (and its FilePresenters) should be serialized as late as possible
    // in the event lifecyle for accurate tracking of time elapsed since uploadAt.

  }, {
    key: "serialize",
    value: function serialize() {
      // `.serialize()` will also serialize the instance's FilePresenters
      var serializedFiles = this.filePresenters.map(function (_fp) {
        return _fp.serialize();
      });
      return {
        version: KJ_UPLOADER_VERSION,
        files: serializedFiles,
        isSuccessful: serializedFiles.length ? serializedFiles.every(function (_file) {
          return _file.isSuccessful;
        }) : null,
        hasFailedFiles: serializedFiles.length ? serializedFiles.some(function (_file) {
          return _file.isFailed;
        }) : null,
        hasErrors: this.errors.length > 0,
        errors: this.errors
      };
    }
  }]);

  return EventPresenter;
}();

export default EventPresenter;